export default {
  'not-found': 'Pagina non trovata',
  'internal-error': 'Impossibile elaborare la richiesta',
  'preview-error':
    "<strong>Lo slug dell'articolo non è valido</strong>.<br/> Controlla che sia compilato il campo slug e che l'articolo sia stato <strong>Pubblicato</strong> o <strong>salvato come Bozza</strong>.",
  continue: 'Continua la navigazione',
  'no-search-results': 'Nessun risultato trovato',
  'back-to-home': 'Torna in home',
}
